import { render, staticRenderFns } from "./StatTaskedStatistic.vue?vue&type=template&id=3ca18f44&scoped=true&"
import script from "./StatTaskedStatistic.vue?vue&type=script&lang=ts&"
export * from "./StatTaskedStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./StatTaskedStatistic.vue?vue&type=style&index=0&id=3ca18f44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca18f44",
  null
  
)

export default component.exports